package com.bikompanion.ui.home

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.MutableStateFlow

/**
 * The scope and the one [HomeViewModel.State] that [HomeViewModel] and its helpers share.
 *
 * A single flow rather than a slice per helper merged with `combine`: everything reads
 * `state.value` straight after writing it, which a merged flow only answers a dispatch later.
 */
class HomeSession(
    val scope: CoroutineScope,
    val state: MutableStateFlow<HomeViewModel.State>,
)
